import { EventViewData } from 'components/eventView/pages/eventData';
import styled from 'styled-components/macro';

const Footer = () => {
    return <S_Footer>Kariéra+ je značka VŠB-TUO</S_Footer>;
};

const S_Footer = styled.div`
    font-size: 12px;
    margin-top: 50px;
    text-align: center;
    color: #fff;
`;

export const KarieraPlus2024Event: EventViewData = {
    eventId: 'karieraplus2024',
    mapId: 'ac17641c-6742-4568-8ecd-519d49e124a3',
    guideId: '6d759437-1ed5-4dae-8d20-38ee02d0aca8',
    mapSettings: {
        standZoom: 0.6
    },
    eventInfo: {
        homepageContent: {
            footer: () => <Footer />
        },
        externalLinkPosition: 'top',
        externalLinkStyle: 'small',
        externalLinkButtonBackground: '#ff0092',
        externalLinkButtonTextColor: '#fff'
    }
};
